<template>
  <div style="background-color: white;height: 100vh">
    <div class="box">
      <div
        style="position: absolute; width: 45px; height: 45px; "
        @click="slip()"
      >
        <img loading="lazy" src="../../assets/slipleft.png" />
      </div>

      <div class="ViewTitle">{{ title }}</div>
      <div class="contain gery">
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          :model="form"
        >
          <el-form-item label="Area code">
            <el-select v-model="form.areaCode" placeholder="Please select an area code">
              <el-option
                v-for="(item, index) in cityCode"
                :key="index"
                :label="`${item.displayMapping.en} (+${item.areaCode})`"
                :value="item.areaCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
                  <!-- 当 gptsUserPhone 为 null 时的简单表单 -->
          <template v-if="!gptsUserPhone || gptsUserPhone === 'null'">
           <el-form-item label="Mobile phone">
              <el-input v-model="form.phone" placeholder="Please enter your phone number"></el-input>
            </el-form-item>
            <el-form-item label="Verification" class="codeBox">
              <el-input v-model="form.code" placeholder="Please enter the verification code"></el-input>
              <el-button type="text" :disabled="codeDisabled" class="setCode" @click="getoriginalCode()">{{ codeBtnText
                }}</el-button>
            </el-form-item>
          </template>

          <!-- 当 gptsUserPhone 不为 null 时的完整表单 -->
          <template v-else>
                <el-form-item label="old phone">
              <el-input v-model="gptsUserPhone" disabled></el-input>
            </el-form-item>
            <el-form-item label="Verification" class="codeBox">
              <el-input v-model="form.code" placeholder="Please enter the verification code"></el-input>
              <el-button type="text" :disabled="oldCodeDisabled" class="setCode" @click="getoldCode()">{{ oldCodeBtnText
                }}</el-button>
            </el-form-item>
            <el-form-item label="new phone">
              <el-input v-model="form.newphone" placeholder="Please enter your phone number"></el-input>
            </el-form-item>
            <el-form-item label="Verification" class="codeBox">
              <el-input v-model="form.newcode" placeholder="Please enter the verification code"></el-input>
              <el-button type="text" :disabled="newCodeDisabled" class="setCode" @click="getnewCode()">{{ newCodeBtnText
                }}</el-button>
            </el-form-item>
          </template>
          <div class="submit" @click="submitnew()">Confirm</div>
        </el-form>
      </div>
    </div>
    <div class="islider" v-if="show">
      <bc-slider
        @validImg="validImg"
        @close="onClose"
        :backgroupImg="backgroupImg"
        :moveImg="moveImg"
        :log="true"
      ></bc-slider>
      <!-- @getImg="getImg" -->
    </div>
  </div>
</template>
<script>
import { smsSend, captcha, captchaVerify, bindPhone } from "@/api/user";
import { shareUrl } from "@/utils/vxshare.js";
import bcSlider from "@/components/sliderpc";
import {getsms, changePhone, bindPhone1} from "@/api/login";
export default {
  name: "ChangePhone",
  components: { bcSlider },
  data() {
    return {
      title: "Modify mobile phone number",
      titleEn: "Modify mobile phone number",
      labelPosition: "right",
      form: {
        areaCode: "",
        phone: "",
        newphone: "",
        code: "",
        newcode: "",
        userId: "",
      },
            // 旧手机号验证码相关
      codeBtnText: 'code',
      oldCodeDisabled: false,
      oldCodeBtnText: ' code',
      oldCodeCountdown: 0,
      oldCodeTimer: null,
      // 新手机号验证码相关
      newCodeDisabled: false,
      newCodeBtnText: 'code',
      newCodeCountdown: 0,
      newCodeTimer: null,

      backToken: "",
      mobile: "",
      secretKey: "",
      backgroupImg: "",
      moveImg: "",
      show: false,
      gptsUserPhone: localStorage.getItem("gptsUserPhone"),
      // gptsUserPhone: null,
      userId: localStorage.getItem("gptsUserId"),
      token:localStorage.getItem("token"),
      cityCode: [],
      disabled: false,
      setCode: "Code",
      setCodeEn: "Verification code",
      languageSelect: "",
    };
  },
  computed: {},
  watch: {
    "$store.state.cityCode"(newValue) {
      this.cityCode = newValue;
    },
  },
  created() {
    this.cityCode = this.$store.state.cityCode;
    localStorage.setItem("myclick", 1);
    if (localStorage.getItem("language")) {
      this.languageSelect = localStorage.getItem("language");
    } else {
      this.languageSelect = "zh";
    }
    this.getImg();
    let type = this.$route.query.type;
    this.title = type == 1 ? "Modify mobile phone number" : "Bind mobile phone number";
    let url = window.location.host;
    // let url = 'https://oilgasinfoai.com/?language=zh'
    setTimeout(() => {
      //encodeURIComponent 将你的URL进行转译一下，因为微信分享出去后会带有多余用不到的参数
      let shareData = {
        url: url,
        title: "Oil & Gas GPT",
      };
      shareUrl(shareData);
    }, 1000);
  },
  methods: {
     topTopmobile() {
      console.log("fuzujianchuanzhi")
      //const element = this.$refs.total;
      //const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
      const element = this.$refs.totalModel;
      const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
      this.$nextTick(() => {
        this.$refs.totalModel.scrollTop = rect
      });
    },
        topTop() {
      console.log("fuzujianchuanzhi")
      //const element = this.$refs.total;
      //const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    },
    onClose() {
      this.show = false;
      this.getImg();
    },
    // 获取滑动验证码（下方有格式截图）
    getImg() {
      captcha().then((res) => {
        this.backToken = res.data.token;
        this.secretKey = res.data.secretKey;
        this.backgroupImg = res.data.originalImageBase64;
        this.moveImg = res.data.jigsawImageBase64;
      });
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(moveX, fn) {
      // moveX为小滑块滑动的距离
      // 330为背景图的宽度，可设置为动态变量，310是偏移量
      const moveLeftDistance = (moveX * 310) / parseInt(330);
      const data = {
        pointJson: JSON.stringify({ x: moveLeftDistance, y: 5.0 }),
        token: this.backToken,
        type: 1,
        phone: this.form.phone,
        areaCode: this.form.areaCode,
        // sender: this.form.phone,
      };
      captchaVerify(data)
        .then((res) => {
          const result = res;
          console.log(res.data);
          if (result.data) {
            this.onClose();
            // 调用登录的请求方法
            let data = {
              phone: this.form.phone,
              areaCode: this.form.areaCode,
              captchaToken: res.data,
              event:
                this.title == "Modify mobile phone number"
                  ? "UPDATE_MOBILE_SMS"
                  : "UPDATE_MOBILE_SMS",
            };
            smsSend(data).then((respon) => {
              if (!respon.data.data) {
                this.$message({
                  message: respon.msg,
                  type: "success",
                });
                this.tackBtn(); //验证码倒数60秒
              } else {
                // console.log(data);
                let data1 = JSON.parse(respon.data.data);
                this.$message({
                  message: data1.error_msg,
                  type: "error",
                });
              }
            });
          } else {
            fn(false);
          }
        })
        .catch(() => {
          fn(false);
        });
      this.show = true;
    },
    slip() {
      this.form = {
        areaCode: "",
        phone: "",
        code: "",
      };
      this.$router.go(-1);
    },
        // 获取新用户绑定手机号的验证码
getoriginalCode() {
  if (!this.validatePhone(this.form.phone)) {
    return;
  }
  this.startOriginalCodeCountdown();
  this.sendSmsCode(this.form.phone, 'original');
},

// 新用户验证码倒计时
startOriginalCodeCountdown() {
  this.codeDisabled = true;
  let countdown = 60;
  this.codeBtnText = `${countdown}Resend`;
  
  const timer = setInterval(() => {
    countdown--;
    this.codeBtnText = `${countdown}Resend`;
    
    if (countdown <= 0) {
      clearInterval(timer);
      this.codeDisabled = false;
      this.codeBtnText = 'code';
    }
  }, 1000);
},

      // 获取旧手机验证码
    getoldCode() {
      if (!this.validatePhone(this.gptsUserPhone)) {
        return;
      }
      this.startOldCodeCountdown();
      this.sendSmsCode(this.gptsUserPhone, 'old');
    },
    
    // 获取新手机验证码
    getnewCode() {
      if (!this.validatePhone(this.form.newphone)) {
        return;
      }
      this.startNewCodeCountdown();
      this.sendSmsCode(this.form.newphone, 'new');
    },
    
    // 手机号验证
    validatePhone(phone) {
      if (!this.form.areaCode) {
        this.$message.error("Please select the areaCode");
        return false;
      }
      if (!phone) {
        this.$message.error("Please enter your phone number");
        return false;
      }
      const reg = /^[1][3-9]\d{9}$/;
      if (!reg.test(phone)) {
        this.$message.error("Please enter the correct phone number");
        return false;
      }
      return true;
    },
    
    // 发送短信验证码
    sendSmsCode(phone, type) {
      getsms({ 
        phone: phone,
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('The verification code has been successfully sent');
        } else {
          this.$message.error(res.msg || 'The verification code has been fail sent.');
          // 发送失败时重置对应按钮状态
          if (type === 'original') {
            this.codeDisabled = false;
            this.codeBtnText = 'code';
          } else if (type === 'old') {
            clearInterval(this.oldCodeTimer);
            this.oldCodeDisabled = false;
            this.oldCodeBtnText = 'code';
          } else {
            clearInterval(this.newCodeTimer);
            this.newCodeDisabled = false;
            this.newCodeBtnText = 'code';
          }
        }
      }).catch(() => {
        this.$message.error('Request failed, please try again.');
      });
    },
    
    // 旧手机号倒计时
    startOldCodeCountdown() {
      this.oldCodeDisabled = true;
      this.oldCodeCountdown = 60;
      this.oldCodeBtnText = `${this.oldCodeCountdown}Resend`;
      
      this.oldCodeTimer = setInterval(() => {
        this.oldCodeCountdown--;
        this.oldCodeBtnText = `${this.oldCodeCountdown}Resend`;
        
        if (this.oldCodeCountdown <= 0) {
          clearInterval(this.oldCodeTimer);
          this.oldCodeDisabled = false;
          this.oldCodeBtnText = 'code';
        }
      }, 1000);
    },
    
    // 新手机号倒计时
    startNewCodeCountdown() {
      this.newCodeDisabled = true;
      this.newCodeCountdown = 60;
      this.newCodeBtnText = `${this.newCodeCountdown}Resend`;
      
      this.newCodeTimer = setInterval(() => {
        this.newCodeCountdown--;
        this.newCodeBtnText = `${this.newCodeCountdown}Resend`;
        
        if (this.newCodeCountdown <= 0) {
          clearInterval(this.newCodeTimer);
          this.newCodeDisabled = false;
          this.newCodeBtnText = 'code';
        }
      }, 1000);
    },
  beforeDestroy() {
    // 组件销毁前清除定时器
    clearInterval(this.oldCodeTimer);
    clearInterval(this.newCodeTimer);
  },
   //提交验证码的新方法
    submitnew() {
          const reg = /^\d{6,13}$/;
      if (!this.form.areaCode) {
        this.$message.error("Please select the areaCode");
        return false;
      }
      // if (!this.form.newphone) {
      //   this.$message.error("请输入手机号");
      //   return false;
      // }
      // if (!reg.test(this.form.newphone)) {
      //   this.$message.error("请输入正确的手机号");
      //   return false;
      // }
      // if (!this.form.code) {
      //   this.$message.error("请输入验证码");
      //   return false;
      // }
      // if (!this.form.newcode) {
      //   this.$message.error("请输入验证码");
      //   return false;
      // }
       // 新用户绑定逻辑
  if (!this.gptsUserPhone || this.gptsUserPhone === 'null') {
    if (!this.form.phone) {
      this.$message.error("Please enter your phone number");
      return false;
    }
    if (!reg.test(this.form.phone)) {
      this.$message.error("Please enter the correct phone number");
      return false;
    }
    if (!this.form.code) {
      this.$message.error("Please enter the verification code");
      return false;
    }
     // 调用 bindPhone 接口
    bindPhone1({
      gptsUserPhone: this.form.phone,
      areaCode: this.form.areaCode,
      code: this.form.code,
      gptsUserId: this.userId,
    }).then((res) => {
      if (res.code === 200) {
        this.$message.success("Binding successful");
        this.$router.push("/secure")
        // localStorage.setItem('gptsUserPhone', this.form.phone);
        // window.location.reload();
      } else {
        this.$message.error(res.msg || "Binding failed");
      }
    });

  } else {
    if (!this.form.newphone) {
      this.$message.error("please enter the new phone number");
      return false;
    }
    if (!reg.test(this.form.newphone)) {
      this.$message.error("please enter the correct phone number");
      return false;
    }
    if (!this.form.code || !this.form.newcode) {
      this.$message.error("Get verification code");
      return false;
    }
    changePhone(
      {gptsUserId:this.userId,
      newPhone:this.form.newphone,
      oldCode:this.form.code,
      newCode:this.form.newcode,
      oldPhone:this.gptsUserPhone,
      areaCode:this.form.areaCode,
    }).then((res) => {
      if (res.code === 200) {
        this.$message.success("Change successful");
        // 成功后更新显示的手机号
        this.currentPhone = this.form.newphone;
        // 更新本地存储
        localStorage.setItem('gptsUserPhone', this.currentPhone);
         window.location.reload(true);
      }else {
          this.$message.error(res.msg || "Change failed");
          // 失败时保持原手机号显示
        }
    })
    }
  },
    //获取验证码 并只验证手机号 是否正确
    getCode() {
      const reg = /^\d{6,13}$/;
      if (!this.form.areaCode) {
        this.$message.error("请选择区号");
        return false;
      }
      if (!this.form.phone) {
        this.$message.error("Please enter your phone number");
        return false;
      }
      if (!reg.test(this.form.phone)) {
        this.$message.error("Please enter your correct phone number");
        return false;
      }
      this.show = true;
    },
    tackBtn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.setCode = "getting...";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.setCode = "Try again in"+time+" seconds";
          time--;
        }
      }, 1000);
    },
    submit() {
      // eslint-disable-next-line no-unreachable
      const reg = /^\d{6,13}$/;
      if (!this.form.areaCode) {
        this.$message.error("Please select an area code");
        return false;
      }
      if (!this.form.phone) {
        this.$message.error("Please enter your phone number");
        return false;
      }
      if (!reg.test(this.form.phone)) {
        this.$message.error("Please enter your correct phone number");
        return false;
      }
      if (!this.form.code) {
        this.$message.error("Please enter the verification code");
        return false;
      }
      this.form.token = localStorage.getItem("Zyaccess_token"); // 竹云token
      this.form.language = this.languageSelect;
      bindPhone(this.form).then(() => {
        this.$message({
          message: "修改成功！", //提示的信息
          type: "success", //类型是成功
          duration: 1200, //显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
          onClose: () => {
            location.reload();
            this.getUserCom();
            this.$router.go(-1);
          },
        });
      });
    },
    getCodeEn() {
      const reg = /^\d{6,13}$/;
      if (!this.form.areaCode) {
        this.$message.error("Please select an area code");
        return false;
      }
      if (!this.form.phone) {
        this.$message.error("Please enter your phone number");
        return false;
      }
      if (!reg.test(this.form.phone)) {
        this.$message.error("Please enter the correct phone number");
        return false;
      }
      this.show = true;
    },
    tackBtnEn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.setCodeEn = "Verification code";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.setCodeEn = "Try again in" + time + " s";
          time--;
        }
      }, 1000);
    },
    submitEn() {
      // eslint-disable-next-line no-unreachable
      const reg = /^\d{6,13}$/;
      if (!this.form.areaCode) {
        this.$message.error("Please select an area code");
        return false;
      }
      if (!this.form.phone) {
        this.$message.error("Please enter your phone number");
        return false;
      }
      if (!reg.test(this.form.phone)) {
        this.$message.error("Please enter the correct phone number");
        return false;
      }
      if (!this.form.code) {
        this.$message.error("Please enter the verification code");
        return false;
      }
      this.form.token = localStorage.getItem("Zyaccess_token"); // 竹云token
      this.form.language = this.languageSelect;
      bindPhone(this.form).then(() => {
        this.$message({
          message: "Modified successfully！", //提示的信息
          type: "success", //类型是成功
          duration: 1200, //显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
          onClose: () => {
            this.getUserCom();
            this.$router.go(-1);
          },
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.gery .el-select {
  width: 100%;
  background: #f5f5f7 !important;
  border-radius: 5px;
}
.gray{

}
.box {
  background: #fff;
  .ViewTitle {
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid #ebebeb;
    font-size: 16px;
    color: #333333;
    font-weight: 400;
    padding: 0 50px;
    text-align: center;
  }
  .contain {
    padding: 25px 15px;
    width: 100vw;
    position: relative;
    .el-form-item {
      margin-bottom: 20px;
    }
    .submit {
      width: 320px;
      height: 56px;
      line-height: 56px;
      text-align: center;
      border-radius: 5px;
      margin: 30px auto 20px auto;
      background: var(--main-color);
      color: #ffffff;
      cursor: pointer;
    }
  }
  .codeBox {
    .el-form-item__content {
      width: 200px !important;
      position: relative;
    }
    .setCode {
      position: absolute;
      right:-20px;
      width: 110px;
      height: 48px;
      // line-height: 50px;
      text-align: center;
      border-radius: 4px;
      background: var(--main-color);
      color: #fff;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  ::v-deep {
    .el-form-item__content {
      width: 200px;}
    .el-input__inner {
      width: 60vw;
      height: 48px;
      font-size: 14px;
      background-color: #fff;
    }

    .el-input__suffix{
      right:-20px;
    }
    .el-form-item__label {
      color: #666;
      font-size: 14px;
      padding-right: 25px;
      line-height: 48px;
    }
  }
}

::v-deep {
  .el-input__inner {
    height: 48px;

  }

  .el-form-item__label {
    color: #666;
    font-size: 14px;
    padding-right: 32px;
    line-height: 48px;
  }
  .codeBox {
    .el-form-item__content {
      .el-input {
        flex: 1;
      }
      .setCode {
        width: 75px;
        height: 48px;
        // line-height: 50px;
        text-align: center;
        border-radius: 4px;
        background: var(--main-color);
        color: #fff;
        font-size: 14px;
        margin-left: 15px;
      }
    }
  }
}
</style>

